export default __webpack_public_path__ + "static/media/src_jquery_mobile_4.1b8ed4f0.jpg";